__turbopack_context__.v({
  "actionArea": "paymentCheckout-module__X3aOTG__actionArea",
  "actionNote": "paymentCheckout-module__X3aOTG__actionNote",
  "amountChoices": "paymentCheckout-module__X3aOTG__amountChoices",
  "balanceCard": "paymentCheckout-module__X3aOTG__balanceCard",
  "balanceMain": "paymentCheckout-module__X3aOTG__balanceMain",
  "body": "paymentCheckout-module__X3aOTG__body",
  "brandMark": "paymentCheckout-module__X3aOTG__brandMark",
  "checkout": "paymentCheckout-module__X3aOTG__checkout",
  "checkout-slide-up": "paymentCheckout-module__X3aOTG__checkout-slide-up",
  "close": "paymentCheckout-module__X3aOTG__close",
  "closeGlyph": "paymentCheckout-module__X3aOTG__closeGlyph",
  "currency": "paymentCheckout-module__X3aOTG__currency",
  "customAmount": "paymentCheckout-module__X3aOTG__customAmount",
  "discount": "paymentCheckout-module__X3aOTG__discount",
  "discountHighlight": "paymentCheckout-module__X3aOTG__discountHighlight",
  "featureStrip": "paymentCheckout-module__X3aOTG__featureStrip",
  "footerTop": "paymentCheckout-module__X3aOTG__footerTop",
  "gatewaySection": "paymentCheckout-module__X3aOTG__gatewaySection",
  "header": "paymentCheckout-module__X3aOTG__header",
  "headerActions": "paymentCheckout-module__X3aOTG__headerActions",
  "headerTitle": "paymentCheckout-module__X3aOTG__headerTitle",
  "insufficientContent": "paymentCheckout-module__X3aOTG__insufficientContent",
  "method": "paymentCheckout-module__X3aOTG__method",
  "methodDisabled": "paymentCheckout-module__X3aOTG__methodDisabled",
  "methodInfo": "paymentCheckout-module__X3aOTG__methodInfo",
  "methodRadio": "paymentCheckout-module__X3aOTG__methodRadio",
  "methodSelected": "paymentCheckout-module__X3aOTG__methodSelected",
  "methodTop": "paymentCheckout-module__X3aOTG__methodTop",
  "methods": "paymentCheckout-module__X3aOTG__methods",
  "miniTag": "paymentCheckout-module__X3aOTG__miniTag",
  "optionMain": "paymentCheckout-module__X3aOTG__optionMain",
  "optionPrice": "paymentCheckout-module__X3aOTG__optionPrice",
  "overlay": "paymentCheckout-module__X3aOTG__overlay",
  "package": "paymentCheckout-module__X3aOTG__package",
  "packageBottom": "paymentCheckout-module__X3aOTG__packageBottom",
  "packageCost": "paymentCheckout-module__X3aOTG__packageCost",
  "packageGrid": "paymentCheckout-module__X3aOTG__packageGrid",
  "packageHeading": "paymentCheckout-module__X3aOTG__packageHeading",
  "packageMeta": "paymentCheckout-module__X3aOTG__packageMeta",
  "packageSelected": "paymentCheckout-module__X3aOTG__packageSelected",
  "packageTitle": "paymentCheckout-module__X3aOTG__packageTitle",
  "packageTop": "paymentCheckout-module__X3aOTG__packageTop",
  "packageUnit": "paymentCheckout-module__X3aOTG__packageUnit",
  "packages": "paymentCheckout-module__X3aOTG__packages",
  "packagesHead": "paymentCheckout-module__X3aOTG__packagesHead",
  "payAmount": "paymentCheckout-module__X3aOTG__payAmount",
  "payLabel": "paymentCheckout-module__X3aOTG__payLabel",
  "paymentContent": "paymentCheckout-module__X3aOTG__paymentContent",
  "paymentHeading": "paymentCheckout-module__X3aOTG__paymentHeading",
  "paymentMethodSection": "paymentCheckout-module__X3aOTG__paymentMethodSection",
  "paymentSection": "paymentCheckout-module__X3aOTG__paymentSection",
  "plansPanel": "paymentCheckout-module__X3aOTG__plansPanel",
  "primaryButton": "paymentCheckout-module__X3aOTG__primaryButton",
  "promo": "paymentCheckout-module__X3aOTG__promo",
  "promoArrow": "paymentCheckout-module__X3aOTG__promoArrow",
  "promoDescription": "paymentCheckout-module__X3aOTG__promoDescription",
  "promoTitle": "paymentCheckout-module__X3aOTG__promoTitle",
  "receipt": "paymentCheckout-module__X3aOTG__receipt",
  "receiptAmount": "paymentCheckout-module__X3aOTG__receiptAmount",
  "receiptIcon": "paymentCheckout-module__X3aOTG__receiptIcon",
  "receiptRow": "paymentCheckout-module__X3aOTG__receiptRow",
  "receiptTitle": "paymentCheckout-module__X3aOTG__receiptTitle",
  "receiptTotal": "paymentCheckout-module__X3aOTG__receiptTotal",
  "resetOrder": "paymentCheckout-module__X3aOTG__resetOrder",
  "savings": "paymentCheckout-module__X3aOTG__savings",
  "sectionHint": "paymentCheckout-module__X3aOTG__sectionHint",
  "sectionTop": "paymentCheckout-module__X3aOTG__sectionTop",
  "secure": "paymentCheckout-module__X3aOTG__secure",
  "selected": "paymentCheckout-module__X3aOTG__selected",
  "selector": "paymentCheckout-module__X3aOTG__selector",
  "singleCheckout": "paymentCheckout-module__X3aOTG__singleCheckout",
  "singleIcon": "paymentCheckout-module__X3aOTG__singleIcon",
  "singleOption": "paymentCheckout-module__X3aOTG__singleOption",
  "singleSummary": "paymentCheckout-module__X3aOTG__singleSummary",
  "summaryPanel": "paymentCheckout-module__X3aOTG__summaryPanel",
  "summaryTop": "paymentCheckout-module__X3aOTG__summaryTop",
  "topup": "paymentCheckout-module__X3aOTG__topup",
  "topupDescription": "paymentCheckout-module__X3aOTG__topupDescription",
  "topupLink": "paymentCheckout-module__X3aOTG__topupLink",
  "walletToggle": "paymentCheckout-module__X3aOTG__walletToggle",
});
